import * as React from 'react'
import { RecommendedArticlesTeaserBlok } from '../../types'
import { StyledRecommendArticlesContainer, StyledRecommendArticlesHeadline } from './styled'
import { RecommendedArticleItem } from './RecommendedArticleItem'
import { componentCategoryMap } from '../../lib/constants'
import { sbEditable } from '@storyblok/storyblok-editable'

export const RecommendedArticlesTeaser = ({ blok }: { blok: RecommendedArticlesTeaserBlok }) => {
  const { recommendedArticles, headline, headlineSyntax = 'h4' } = blok

  const isListView = recommendedArticles.length > 1

  return (
    <StyledRecommendArticlesContainer className="recommended-articles" {...sbEditable(blok)} $isSmall={isListView}>
      {headline && (
        <StyledRecommendArticlesHeadline as={headlineSyntax} className="recommended-articles-headline">
          {headline}
        </StyledRecommendArticlesHeadline>
      )}

      {recommendedArticles.map(({ uuid, name, content, full_slug }) => {
        const { title, companyLogo, media, postCategory, component, useCaseIcon } = content || {}

        return (
          <RecommendedArticleItem
            title={title}
            image={media || companyLogo || useCaseIcon}
            category={postCategory || componentCategoryMap[component]}
            key={uuid}
            isListView={isListView}
            component={component}
            to={`/${full_slug}`}
          />
        )
      })}
    </StyledRecommendArticlesContainer>
  )
}
